import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { setFullPatientMedicalHistoryOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'
import { filterHiddenOptions } from '../../../utilities/options.util'
import { IHideableOptionsResponse } from '../store/options.types'

export function* setMedicalFullHistoryOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const medicalFullHistoryResponse: IHideableOptionsResponse = yield call([
      optionsService,
      optionsService.getMedicalHistoryBasicFullListOptions,
    ])
    const { entity } = medicalFullHistoryResponse
    yield put(setFullPatientMedicalHistoryOptions(filterHiddenOptions(entity)))
  } catch (e) {
    yield put(throwPcrException(`setMedicalFullHistoryOptions() error: ${e}`))
  }
}

export function* setMedicalFullHistoryOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setMedicalFullHistoryOptions)
}
